<template>
    <div class="intervenant-item d-flex flex-column align-items-center mx-4 my-md-5 my-4">
        <div class="intervenant-item__photo rounded-circle d-flex-center">
            <img :src="photoUrl" alt="" class="h-100 w-100" />
        </div>
        <span class="intervenant-item__name text-400">{{ intervenant.fullName ?? "" }}</span>
        <small class="intervenant-item__job">{{ intervenant.jobTitle ?? "" }}</small>
    </div>
</template>

<script>
export default {
    props: {
        intervenant: Object,
    },
    data() {
        var getPhotoUrl = () => require(`@/assets/img/intervenants/${this.intervenant.photoPath}`);
        return {
            photoUrl: getPhotoUrl(),
        };
    },
};
</script>

<style lang="scss">
.intervenant-item {
    &__photo {
        overflow: hidden;
        width: 250px;
        height: 250px;

        img {
            object-fit: cover;
            object-position: center;
        }
    }
    &__name {
        margin-top: 1rem;
    }
    &__job {
    }
}
</style>
